import {Link} from "react-router-dom";

export function EventsSection() {
  const events = [
    {
      title: 'PRIVATE CLASS',
      price: '$150',
      features: [
        'Limited to 1 class Yoga & Fitness',
        'max 10 people capacity'
      ],
      buttonText: 'Book Now',
      link: '/buy-now'
    },
    {
      title: 'PRIVATE EVENT ADULTS',
      price: '$499',
      features: [
        '2 Hours',
        '1 hour of your choice workshop (Yoga, Fitness, Dance)',
        '1 hour of celebration',
        '$100 extra for tea ceremony, sound bath or 1 hour of celebration',
        'max 20 people capacity',
        'Music'
      ],
      buttonText: 'Book Now',
      link: '/events-adults'
    },
    {
      title: 'PRIVATE EVENT KIDS',
      price: '$499',
      features: [
        '2 Hours',
        '1 hour of workshop of your choice (Yoga, Fitness, Dance)',
        '1 hour of celebration ($100 for +1 hour of celebration)',
        'max 20 people',
        'Music'
      ],
      buttonText: 'Book Now',
      link: '/events-children'
    }
  ];

  return (
    <section className="py-8 pb-20">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-3xl font-bold text-[#00889D] mb-4 md:mb-12">Events</h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {events.map((event, index) => (
              <div key={index}
                   className="price-box bg-white rounded-2xl border-2 border-gray-200 p-8 shadow-lg flex flex-col">
                {/* Header with title and price */}
                <div className="title flex justify-between items-center">
                  <div className="text-[#025893] font-bold text-2xl">{event.title}</div>
                  <div className="text-5xl font-bold text-[#00889D]">{event.price}</div>
                </div>

                {/* Features list */}
                <div className="space-y-3 mb-8 flex-grow">
                  {event.features.map((feature, featureIndex) => (
                      <div key={featureIndex} className="flex items-start">
                        <i className="ri-check-line text-[#00889D] mr-3 text-xl mt-0.5 flex-shrink-0"></i>
                        <span className="text-gray-700 text-left">{feature}</span>
                      </div>
                  ))}
                </div>

                <Link to={event.link} className="block w-full py-2 px-2 rounded-lg text-white font-semibold whitespace-nowrap cursor-pointer bg-[#00889D] hover:bg-[#007089] text-lg text-center">
                  {event.buttonText}
                </Link>
              </div>
          ))}
        </div>
      </div>
    </section>
  );
}
